import { inject } from '@angular/core';
import {
	ActivatedRouteSnapshot,
	CanActivateChildFn,
	Router,
	RouterStateSnapshot,
	UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { UserStoreService } from '@user-store';
import { MenuPointService, NavVariant } from '@agilox/common';
import { MenuPointUrl } from '../shared/enums/menupoint-url.enum';

export const roleGuard: CanActivateChildFn = (
	route: ActivatedRouteSnapshot,
	state: RouterStateSnapshot
): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
	const userStore = inject(UserStoreService);
	const router = inject(Router);
	const menuPointService = inject(MenuPointService);

	const user = userStore.currentUser();
	if (!user) return false;

	const menupoints = menuPointService.getMenuPointsByCategory(NavVariant.DESKTOP, user.role);

	const urlWithoutParams = state.url.split('?')[0];
	const canActivate = menupoints.some(
		(menuPoint) =>
			menuPoint.url === urlWithoutParams ||
			menuPoint.submenus?.some((submenu) => submenu.url === urlWithoutParams) ||
			(!menuPoint.submenus && urlWithoutParams.includes(menuPoint.url) && menuPoint.url !== '')
	);

	if (canActivate) {
		return true;
	} else if (user) {
		/**
		 * If access to the dashboard is denied, redirect to the remote page.
		 * Partners do not have access to the dashboard.
		 */
		if (state.url.includes(MenuPointUrl.DASHBOARD)) {
			return router.parseUrl(MenuPointUrl.REMOTE);
		}
		return router.parseUrl(MenuPointUrl.DASHBOARD);
	}
	return false;
};
